import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "items-container"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "item-content-container"
};
import { ref, computed, watch, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { inApostleType, inLoggedType, isUserType } from '@/tools/utils';
import router from '@/router';
import store from '@/store';
import { sliderStyle } from "@/theme/sliderStyle";
import { isOpenDrawer } from "@/theme/drawerStyle";
import { ElImage } from "element-plus";
import RippleAvatar from "@/components/Account/RippleAvatar.vue"; // constants

const accountPath = '/account'; // router

export default {
  __name: 'NavigatorBar',

  setup(__props) {
    const baseDataArray = [{
      name: '首页',
      path: '/',
      icon: require('@/assets/icon/navi_icon_home.png')
    }, {
      name: '世界观',
      path: '/worldOutlook',
      icon: require('@/assets/icon/navi_icon_wo.png')
    }, {
      name: '剧本',
      path: '/drama',
      icon: require('@/assets/icon/navi_icon_drama.png')
    }, {
      name: '海市',
      path: '/market',
      icon: require('@/assets/icon/navi_icon_market.png')
    }, {
      name: '主厅',
      path: '/lounge',
      icon: require('@/assets/icon/navi_icon_lounge.png')
    }];
    const apostleStageDataArray = [{
      name: '舞台',
      path: '/stage',
      icon: require('@/assets/icon/navi_icon_stage.png')
    }, {
      name: '后台',
      path: '/backstage',
      icon: require('@/assets/icon/navi_icon_backstage.png')
    }];
    const userStageDataArray = [{
      name: '舞台',
      path: '/stage',
      icon: require('@/assets/icon/navi_icon_stage.png')
    }, {
      name: '候场室',
      path: '/greenRoom',
      icon: require('@/assets/icon/navi_icon_greenroom.png')
    }];
    const ceremony = {
      name: '庆典',
      path: '/ceremony',
      icon: require('@/assets/icon/navi_icon_celemony.png')
    }; // const accountIcon = require('@/assets/icon/navi_icon_account.png')

    const route = useRoute(); // refs

    const activePath = ref(null); // computed

    const user = computed(() => store.state.user);
    const userType = computed(() => store.state.user ? parseInt(store.state.user.user_type) : null);
    const worldOutlook = computed(() => store.state.world_outlook);
    const stage = computed(() => store.state.stage || null);
    const ticketRole = computed(() => store.state.stage_role ?? null);
    const ceremonies = computed(() => {
      if (!worldOutlook.value) return [];
      return store.state.world_outlook_info[worldOutlook.value.id]?.ceremonies ?? null;
    });
    const dataArray = computed(() => {
      if (stage.value) {
        if (inApostleType(userType.value)) {
          return apostleStageDataArray;
        } else {
          if (ticketRole.value && ticketRole.value.position === 'actor') {
            return userStageDataArray;
          } else {
            return userStageDataArray.slice(0, 1);
          }
        }
      }

      if (isUserType(userType.value) && ceremonies.value && ceremonies.value.length > 0) {
        return [...baseDataArray, ceremony];
      }

      return baseDataArray;
    }); // functions

    const toPage = path => {
      // if (stage.value && path === '/stage') {
      //   activePath.value = path
      //   router.push(`${path}/${stage.value.stage_id}`)
      //   return
      // }
      activePath.value = path;
      router.push(path);
    };

    const toAccount = () => {
      if (activePath.value === accountPath) {
        if (!isOpenDrawer.value) isOpenDrawer.value = true;
      } else {
        activePath.value = accountPath;
        router.push(accountPath);
      }
    };

    const isSelectedPath = value => {
      const currentPath = router.currentRoute.value.path; // console.log(`activePath.value = ${activePath.value} ${JSON.stringify(router.currentRoute.value.path)}`)
      // if (currentPath && currentPath.startsWith('/stage')) {
      //   return value.path === '/stage'
      // }

      return value.path === currentPath;
    };

    const getRouterName = name => {
      if (!stage.value) {
        switch (name) {
          case '世界观':
            return worldOutlook.value ? worldOutlook.value.name : name;

          case '主厅':
            return stage.value ? '后台' : name;

          default:
            return name;
        }
      } else {
        return name;
      }
    }; // lifecycle


    onMounted(() => {
      toAccount();
    }); // watcher

    watch(() => route.path, to => {
      if (worldOutlook.value && userType.value && !activePath.value) {
        const target = dataArray.value.find(item => item.path === to) || (to === accountPath ? accountPath : null);
        activePath.value = target || 'None';
      }
    });
    watch(userType, existence => {
      if (!existence) {
        toAccount();
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "navigator-bar",
        style: _normalizeStyle(_unref(sliderStyle))
      }, [_unref(inLoggedType)(userType.value) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataArray.value, (value, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(['item-card', isSelectedPath(value) ? 'selected-item-card' : '']),
          onClick: $event => toPage(value.path)
        }, [_cache[0] || (_cache[0] = _createElementVNode("div", {
          class: "selected-icon selected-icon-left"
        }, null, -1)), _createElementVNode("div", _hoisted_3, [_createVNode(_unref(ElImage), {
          src: value.icon
        }, null, 8, ["src"]), _createElementVNode("text", null, _toDisplayString(getRouterName(value.name)), 1)]), _cache[1] || (_cache[1] = _createElementVNode("div", {
          class: "selected-icon selected-icon-right"
        }, null, -1))], 10, _hoisted_2);
      }), 128))])) : _createCommentVNode("", true), _createVNode(RippleAvatar, {
        "avatar-url": user.value.avatar,
        onClick: toAccount
      }, null, 8, ["avatar-url"])], 4);
    };
  }

};